import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';

import keyboard from '../img/keyboard.png'
import DesignCard from './DesignCard';
// import KeyIcon from '@material-ui/icons/KeyboardTwoTone';
import KeyIcon from '@material-ui/icons/Keyboard';

// import designerIconStyle from './designIconStyle';

export default memo(({ data }) => {

  const designerIconStyle = {
    // backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', padding:'5px', borderRadius:'25px', marginLeft:'10px'
    padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'

  }


    return (
    <div className="designnode">
      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />

      <KeyIcon className='designicon' fontSize='medium' style={designerIconStyle} draggable={false}/>

      {/* <img draggable={false} src={keyboard} width='50' height='50'></img> */}
      <DesignCard attributes={data.attributes} name={data.label}/>

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );
});